import { Button, Text } from '@cretesuite/design-system'
import { IonContent, IonPage, IonSpinner } from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { useHistory } from 'react-router-dom'
import { Logo } from '../components/Logo'
import { useCurrentUser } from '../hooks/useCurrentUser'
import { useOrganization } from '../hooks/useOrganization'

export const WelcomePage = () => {
  const { _ } = useLingui()
  const history = useHistory()
  const { user, loading } = useCurrentUser()
  const { organization } = useOrganization()

  return (
    <IonPage>
      <IonContent fullscreen className='ion-padding'>
        <div className='welcome-layout'>
          <div className='welcome-logo'>
            <Logo />
          </div>

          {loading ? (
            <div className='welcome-loading'>
              <IonSpinner name='crescent' />
            </div>
          ) : (
            <>
              <h1 className='welcome-heading'>
                {_(msg`Welcome`)}{' '}
                <span className='welcome-name'>{user?.firstName}</span>
              </h1>

              <Text variant='body' className='welcome-message'>
                <strong>{organization?.name}</strong>{' '}
                {_(
                  msg`partners with CreteSuite to help you track your assignments, complete work tickets, and more.`,
                )}
              </Text>

              <div className='welcome-actions'>
                {organization?.logo && (
                  <img
                    src={organization.logo}
                    alt={organization.name}
                    className='welcome-org-logo'
                  />
                )}

                <Button
                  variant='primary'
                  size='lg'
                  className='welcome-cta'
                  onClick={() => history.replace('/assignments')}
                >
                  {_(msg`Go to my Assignments`)}
                </Button>
              </div>
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  )
}

export default WelcomePage
